import { Show } from "shared/components";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { DecisionAction } from "shared/types";
import { cx } from "shared/utils";
import { ApplicationStatus } from "shared/types";

export const RecommendationButton = ({
  recommendation,
  onClickMakeDecision,
  onClickExplainRecommendation,
  canMakeDecision,
  hasReasons = false,
  autoApproved
}: {
  recommendation?: DecisionAction;
  onClickMakeDecision: () => void;
  onClickExplainRecommendation?: () => void;
  canMakeDecision?: boolean;
  className?: string;
  hasReasons?: boolean;
  status?: ApplicationStatus;
  autoApproved?: boolean;
}) => {
  return (
    <div className="space-y-2 w-full">
      <Show if={canMakeDecision}>
        <Button
          className={cx(
            "w-full",
            recommendation === DecisionAction.Approve
              ? "bg-success-500 hover:bg-success-600"
              : recommendation === DecisionAction.Decline
                ? "!bg-danger-500 !hover:bg-danger-600"
                : recommendation === DecisionAction.ConditionalApprove
                  ? "bg-warning-500 hover:bg-warning-600"
                  : ""
          )}
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          onClick={onClickMakeDecision}
          disabled={!canMakeDecision}
        >
          {recommendation === DecisionAction.Approve
            ? "Approve application"
            : recommendation === DecisionAction.Decline
              ? "Decline application"
              : recommendation === DecisionAction.ConditionalApprove
                ? "Conditionally approve application"
                : "Make decision"}
        </Button>
      </Show>

      <Show if={hasReasons}>
        <Button
          onClick={onClickExplainRecommendation}
          size={ButtonSize.SM}
          className="w-full"
        >
          Explain {autoApproved ? "decision" : "recommendation"}
        </Button>
      </Show>
    </div>
  );
};
